import classNames from "classnames";
import React from "react";

export const getPlatform = () => {
	const userAgent =
		navigator.userAgent || navigator.vendor || (window as any).opera;

	return {
		isAndroid: /android/i.test(userAgent),
		isIOS: /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream,
		isWeb:
			!/android/i.test(userAgent) &&
			!(/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream),
	};
};

export function partialComponent<P extends object, K extends keyof P>(
	Component: React.ComponentType<P>,
	partialProps: Pick<P, K>,
) {
	type PartialKeys = Partial<Pick<P, K>>;
	type RestProps = Omit<P, K> & PartialKeys;

	const Wrapped: React.FC<RestProps> = (props) => {
		// Start with partialProps and let incoming props override them
		const merged = {
			...(partialProps as unknown as Partial<P>),
			...(props as Partial<P>),
		} as P;

		// If there is a className in either, merge them instead of overriding
		const partialClass = (partialProps as any)?.className;
		const propClass = (props as any)?.className;
		if (partialClass || propClass) {
			(merged as any).className = classNames(partialClass, propClass);
		}

		return <Component {...merged} />;
	};

	return Wrapped;
}
